import { signalStore } from '@ngrx/signals';
import { AbstractQueryParams, OffSubscriptionWithCatch, withActions, withSelectors } from '@res/ngg-core';
import { IssueData, IssueModel, IssueRef } from '../../schema/schema.interface';
import { IssueActions } from './issue.action';
import { IssueState } from './issue.state';
export type IssueStoreModel = IssueData & { ref: IssueRef };
export interface IssueStateModel {
  issues: IssueStoreModel[];
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean;
  filter?: { query: AbstractQueryParams<IssueModel>[] };
}

export const IssueStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    issues: IssueState.issues,
    issueState: IssueState.issueState,
  }),
  // Actions
  withActions({
    getAllIssues: IssueActions.GetAllIssue,
    initIssues: IssueActions.InitIssues,
    updateIssue: IssueActions.UpdateIssue,
    queryIssue: IssueActions.QueryIssue,
  }),
);
